export const ACTIONS = {
  SEND_TEACHER_CHAT_MESSAGE: 'SEND_TEACHER_CHAT_MESSAGE',
  RECEIVE_TEACHER_CHAT_MESSAGE: 'RECEIVE_TEACHER_CHAT_MESSAGE',
  SEND_TEACHER_READ_CHAT_MESSAGE: 'SEND_TEACHER_READ_CHAT_MESSAGE',
  RECEIVE_TEACHER_READ_CHAT_MESSAGE: 'RECEIVE_TEACHER_READ_CHAT_MESSAGE',
};

export const sendTeacherChatMessage = (channel, message, meta) => ({
  type: ACTIONS.SEND_TEACHER_CHAT_MESSAGE,
  payload: {
    channel,
    message,
    meta,
  },
});

export const receiveTeacherChatMessage = (message, meta) => dispatch => {
  dispatch({
    type: ACTIONS.RECEIVE_TEACHER_CHAT_MESSAGE,
    payload: {
      message,
      meta,
    },
  });
};

export const sendTeacherReadChatMessage = (channel, message, meta) => dispatch => {
  dispatch({
    type: ACTIONS.SEND_TEACHER_READ_CHAT_MESSAGE,
    payload: {
      channel,
      message,
      meta,
    },
  });
};

export const receiveTeacherReadChatMessage = (message, meta) => dispatch => {
  dispatch({
    type: ACTIONS.RECEIVE_TEACHER_READ_CHAT_MESSAGE,
    payload: {
      message,
      meta,
    },
  });
};
